import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelope } from '@fortawesome/free-solid-svg-icons'
import { SetUnbalanceNotificationReview, SecondaryCta } from 'components'
import React from 'react'

function GridUnbalanceNotificationReview(row) {
  return (
    <div className="flex flex-row-reverse flex-nowrap justify-between items-center gap-4 w-full">
      <SetUnbalanceNotificationReview
        togglerComponent={SecondaryCta}
        togglerProps={{
          size: 'grid',
          className: 'min-w-[20em]',
        }}
        rowData={row}
      >
        <FontAwesomeIcon icon={faEnvelope} fixedWidth />
      </SetUnbalanceNotificationReview>
    </div>
  )
}
export const MemoizedGridUnBalanceNotificationReview = React.memo(
  GridUnbalanceNotificationReview
)
